import { useFormContext } from 'react-hook-form'
import { useFormDisable } from './form'
import { FormNewLabel } from './form-label'

export const FormNewText = ({ name, label, placeholder, required, disabled, autoFocus, subtext }) => {
  const { register } = useFormContext()

  const formDisabled = useFormDisable()
  // formDisabled (read-only form, or a submit in flight) goes on the element,
  // not into register(): react-hook-form 7.54 re-checks dirtiness whenever a
  // registered field's `disabled` option is a boolean, reading the DOM during
  // render, which shows phantom unsaved changes after a reset or a submit.
  // A field that is always disabled still registers as disabled, so its value
  // stays out of the submitted data as before.

  return (
    <FormNewLabel name={name} label={label} required={required} subtext={subtext}>
      <input
        className="form-control"
        type="text"
        {...register(name, { required, ...(disabled ? { disabled: true } : {}) })}
        disabled={formDisabled || disabled}
        placeholder={placeholder || name}
        autoFocus={autoFocus}
      />
    </FormNewLabel>
  )
}
